// The `.button` visual contract, shared by `Button` (<button>) and `ButtonLink` (<a>)
// so the two can never drift. Both render the same classes from `Button/index.scss`.
export type ButtonVariant =
  | 'primary'
  | 'primary-light'
  | 'secondary'
  | 'secondary-light'
  | 'outline'
  | 'outline-on-dark'
  | 'danger'
  | 'ghost'
  | 'icon'
  | 'icon-danger'
  | 'tooltip'

export type ButtonSize = 'medium' | 'small'

export interface ButtonAppearance {
  variant?: ButtonVariant
  size?: ButtonSize
  isActive?: boolean
  className?: string
}

export function buttonClassName({
  variant = 'primary',
  size = 'medium',
  isActive = false,
  className = '',
}: ButtonAppearance): string {
  return ['button', `button--${variant}`, `button--${size}`, isActive && 'button--active', className]
    .filter(Boolean)
    .join(' ')
}
